import { toast } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { domain } from 'modules/data';
import { memo, useCallback } from 'react';
import { useGetQBooksBudgets, useSyncQBooksBudgets } from 'shared/data/webApp/v2';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { useToggleQBooksBudgetsSync } from '../../hooks/useToggleQBooksBudgetsSync';
import { syncQBooksBudgetsPageState } from '../../states';
import PullBudgetButton from '../PullBudgetButton/PullBudgetButton';
import { messages } from './PullQBooksBudgetButton.messages';

export const PullQBooksBudgetButton = memo(() => {
    const company = useCompanyBasedOnUrl();

    const [syncQBooksBudgetsState, setSyncQBooksBudgetsState] = useAtom(syncQBooksBudgetsPageState);

    const { toggleSync, isLoading } = useToggleQBooksBudgetsSync(company);

    const { mutate: syncQBooksBudgets, isLoading: isLoadingSyncQBooksBudgets } = useSyncQBooksBudgets({
        onSuccess: () => {
            toast.success(messages.syncSuccessful);

            setSyncQBooksBudgetsState(true);
        },
    });

    const { data: budgets } = useGetQBooksBudgets({
        path: { companyId: company.id },
    });

    const handleButtonClick = useCallback(() => {
        if (budgets?.isSyncEnabled) {
            syncQBooksBudgets({
                params: {
                    path: {
                        companyId: company.id,
                    },
                },
            });
        } else {
            toggleSync(true);
        }
    }, [budgets?.isSyncEnabled, company.id, syncQBooksBudgets, toggleSync]);

    return (
        <PullBudgetButton
            disabled={syncQBooksBudgetsState || company.isReadonly}
            onClick={handleButtonClick}
            integrationType={domain.IntegrationType.QBooks}
            isLoading={isLoading || isLoadingSyncQBooksBudgets}
        />
    );
});

PullQBooksBudgetButton.displayName = 'PullQBooksBudgetButton';
